import { User, userQueryKey } from '@alluradirect/react';
import { SignupCreateAccount } from 'components/views/pages/signup/SignupCreateAccount';
import { useQueryClient } from 'react-query';

interface Props {
  initialEmail: string;
  close: () => void;
}

export const CheckoutCreateAccountForm = ({ initialEmail, close }: Props) => {
  const qClient = useQueryClient();

  const onSuccess = async (_data: User) => {
    await qClient.invalidateQueries(userQueryKey);
    close();
  };

  return (
    <SignupCreateAccount
      hasTopAppDivider={false}
      navigateOnSuccess={onSuccess}
      hasFooter={false}
      initialEmail={initialEmail}
      isEmailFieldDisabled={true}
    />
  );
};
